/**
 * @class {RPC}
 * @param {String} url
 * @param {Object} [par]
 */
const RPC = Class(
	/**
	 * @lends {RPC#}
	 */
	{
		/**
		 * @param {String} url
		 * @param {Object} [par]
		 * @constructs
		 */
		__construct: function (url, par) {
			par = par || {};
			this.url = url;
			this.async = true;
			if (typeof par.async !== 'undefined') {
				this.async = Boolean(par.async);
			}
		},

		send: function (method, data, callback) {
			callback = callback || null;
			$.ajax({
				url: this.url,
				type: 'POST',
				data: JSON.stringify({
					method: method,
					data: data
				}),
				contentType: false,
				success: D.closure(this, this._response, callback),
				async: this.async,
				error: function (xhr) {
					if (xhr.status === 403) {
						D.reload();
					}
				}
			});
		},

		_response: function (callback, response) {
			if (!callback) {
				return;
			}
			let data = JSON.parse(response);
			if (typeof data !== 'object') {
				D.console.error(response);
				return;
			}
			if (typeof data.ok === 'undefined') {
				D.console.error(response);
				return;
			}
			try {
				callback(data.ok);
				if (!empty(data.ob)) {
					D.console.warn(data.ob);
				}
			} catch (e) {
				D.console.error(e);
			}
		}
	}
);